import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { useDndContext } from "@dnd-kit/core";
import RpMUIDialog from "./modals/RpMUIModal";
import ImageRP from "./ImageRP";

type ZoomableImageProps = {
  children?: React.ReactNode;
  src?: string;
  zoomSrc?: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  dndId?: string | number;
};

const ZoomableImage = ({
  children,
  src,
  zoomSrc,
  alt = "Image Preview",
  width = 100,
  height = 100,
  dndId,
}: ZoomableImageProps) => {
  const [openZoom, setOpenZoom] = useState(false);
  const { active } = useDndContext();

  const isDragging = active && active.id === dndId;

  const handleZoomOpen = (e?: React.MouseEvent | React.PointerEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setOpenZoom(true);
  };

  const handleZoomClose = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    setOpenZoom(false);
  };

  return (
    <>
      <Box
        sx={{
          position: "relative",
          width: width,
          height: height,
          ":hover .zoom-icon": {
            display: !isDragging ? "flex" : "none",
          },
        }}
      >
        {children}
        {!isDragging && (
          <IconButton
            className="zoom-icon"
            onClick={handleZoomOpen}
            onPointerDown={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            size="small"
            sx={(theme) => ({
              position: "absolute",
              top: 2,
              right: 2,
              backgroundColor:
                "color-mix(in srgb, var(--neutral-white) 90%, transparent)",
              color: theme.palette.primary.main,
              zIndex: 10,
              display: "none",
              padding: "2px",
              "&:hover": {
                backgroundColor: "var(--neutral-white)",
                color: theme.palette.primary.dark,
              },
            })}
          >
            <ZoomInIcon fontSize="small" />
          </IconButton>
        )}
      </Box>

      <RpMUIDialog
        open={openZoom}
        onClose={() => handleZoomClose()}
        heading={alt}
        maxWidth="md"
        fullWidth
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 300,
            p: 1,
          }}
        >
          <ImageRP
            src={zoomSrc || src}
            type="BASE64"
            alt={alt}
            style={{
              maxWidth: "100%",
              maxHeight: "75vh",
              width: "100%",
              height: "auto",
              objectFit: "contain",
              border: "1px solid var(--neutral-200)",
            }}
          />
        </Box>
      </RpMUIDialog>
    </>
  );
};

export default ZoomableImage;
